import React from 'react';
import { Lock } from 'lucide-react';
import { useUpsell } from './UpsellContext';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  size?: 'normal' | 'large';
  pulse?: boolean;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text = 'QUIERO MI BIBLIOTECA MÁGICA',
  subtext = 'Acceso inmediato · Pago 100% seguro',
  className = '',
  size = 'normal',
  pulse = true
}) => {
  const {
    openUpsell
  } = useUpsell();
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-45">
      <button type="button" onClick={openUpsell} className={`
          w-full block text-center cta-gradient text-violet font-rounded font-bold uppercase tracking-wide
          rounded-2xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]
          border-b-[5px] border-[#c89020]
          ${pulse ? 'cta-pulse' : 'shadow-cta'}
          ${size === 'large' ? 'py-5 px-6 text-xl sm:text-2xl md:text-3xl' : 'py-4 px-5 text-lg sm:text-xl'}
        `} data-id="element-46">
        {text}
      </button>
      {subtext && <div className="flex items-center justify-center gap-1.5 mt-3 text-textsoft text-xs sm:text-sm font-bold" data-id="element-47">
          <Lock size={12} data-id="element-48" />
          <span data-id="element-49">{subtext}</span>
        </div>}
    </div>;
};